import React from "react";
import img1 from "./userImages/profile.png";

const userData = [
  {
    id: 1,
    img: img1,
    name: "Ajith",
    age: 25,
    jobTitle: "Networking",
    skills: ["Networking", "Troubleshooting", "IP Management"],
  },
  {
    id: 2,
    img: img1,
    name: "Suresh",
    age: 26,
    jobTitle: "Frontend Developer",
    skills: ["React", "Redux", "Javascript", "CSS"],
  },
  {
    id: 3,
    img: img1,
    name: "Jeeva",
    age: 28,
    jobTitle: "Software Test Engineer",
    skills: ["Manual Testing", "Automation Testing"],
  },
  {
    id: 4,
    img: img1,
    name: "Karthik",
    age: 30,
    jobTitle: "Frontend Developer",
    skills: ["React", "Redux", "JavaScript", "CSS"],
  },
  {
    id: 5,
    img: img1,
    name: "Divya",
    age: 26,
    jobTitle: "Backend Developer",
    skills: ["Node.js", "Express", "MongoDB", "SQL"],
  },
  {
    id: 6,
    img: img1,
    name: "Ajith",
    age: 29,
    jobTitle: "Full Stack Developer",
    skills: ["React", "Node.js", "GraphQL", "Docker"],
  },
  {
    id: 7,
    img: img1,
    name: "Meena",
    age: 27,
    jobTitle: "UI/UX Designer",
    skills: ["Figma", "Adobe XD", "Wireframing", "Prototyping"],
  },
  {
    id: 8,
    img: img1,
    name: "Prakash",
    age: 32,
    jobTitle: "DevOps Engineer",
    skills: ["AWS", "Jenkins", "Kubernetes", "Terraform"],
  },
  {
    id: 9,
    img: img1,
    name: "Sandhya",
    age: 25,
    jobTitle: "Mobile App Developer",
    skills: ["React Native", "Flutter", "iOS", "Android"],
  },
  {
    id: 10,
    img: img1,
    name: "Ravi",
    age: 31,
    jobTitle: "Database Administrator",
    skills: ["MySQL", "PostgreSQL", "Oracle", "SQL Server"],
  },
  {
    id: 11,
    img: img1,
    name: "Anitha",
    age: 24,
    jobTitle: "Quality Analyst",
    skills: ["Test Cases", "Selenium", "JIRA", "Bug Tracking"],
  },
  {
    id: 12,
    img: img1,
    name: "Vignesh",
    age: 33,
    jobTitle: "Cloud Architect",
    skills: ["Azure", "AWS", "Google Cloud", "CI/CD"],
  },
  {
    id: 13,
    img: img1,
    name: "Lakshmi",
    age: 28,
    jobTitle: "Business Analyst",
    skills: ["Requirement Gathering", "Agile", "Documentation", "SQL"],
  },
];

export default userData;
